<template>
  <div class="page container p-4 py-4">
    <section class="contact-hero text-center mb-4">
      <span class="section-eyebrow">Fale conosco</span>
      <h2 class="mb-2 text-primary-emphasis">Envie uma mensagem</h2>
      <p class="text-muted mb-0 description-text">Nos conte como podemos ajudar. Respondemos o mais rápido possível.</p>
    </section>

    <form @submit.prevent="submitForm" class="contact-form">
      <div class="row g-2 mb-3">
        <div class="col-12 col-md-6">
          <label class="field-label">Nome</label>
          <input
            v-model.trim="form.name"
            type="text"
            class="form-control contact-input"
            placeholder="Seu nome completo"
            required
          />
        </div>
        <div class="col-12 col-md-6">
          <label class="field-label">E-mail</label>
          <input
            v-model.trim="form.email"
            type="email"
            class="form-control contact-input"
            placeholder="seu@email.com"
            required
          />
        </div>
      </div>

      <div class="mb-3">
        <label class="field-label">Assunto</label>
        <select v-model="form.subject" class="form-select contact-input" required>
          <option value="" disabled>Selecione um assunto</option>
          <option value="business_partnerships">Parcerias Comerciais</option>
          <option value="influencer_partnerships">Parcerias Influencers</option>
          <option value="questions">Dúvidas</option>
          <option value="complaints">Reclamações</option>
          <option value="others">Outros Assuntos</option>
        </select>
      </div>

      <div class="mb-4">
        <label class="field-label">Mensagem</label>
        <textarea
          v-model.trim="form.message"
          class="form-control contact-input"
          rows="6"
          placeholder="Escreva sua mensagem"
          required
        ></textarea>
      </div>

      <div class="d-grid">
        <button
          v-if="!messageSent"
          type="submit"
          class="btn btn-color-site btn-lg contact-btn"
          :disabled="isSubmitting"
        >
          <span v-if="isSubmitting">
            <i class="fas fa-spinner fa-spin me-2"></i>Enviando...
          </span>
          <span v-else>
            <i class="fas fa-paper-plane me-2"></i>Enviar Mensagem
          </span>
        </button>

        <button
          v-else
          type="button"
          class="btn btn-lg contact-btn contact-btn--success"
          disabled
        >
          <i class="fas fa-check me-2"></i>Mensagem enviada com sucesso
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import api from '@/services/api';
import { toast } from 'vue3-toastify';

export default {
  name: 'ContactPage',
  data() {
    return {
      form: {
        name: '',
        email: '',
        subject: '',
        message: '',
      },
      isSubmitting: false,
      messageSent: false,
    };
  },
  methods: {
    async submitForm() {
      if (this.messageSent || this.isSubmitting) return;

      this.isSubmitting = true;
      try {
        await api.post('/contact', this.form);
        this.messageSent = true;
        toast.success('Mensagem enviada com sucesso!');
      } catch (error) {
        const backendMessage = error?.response?.data?.error;
        toast.error(backendMessage || 'Não foi possível enviar sua mensagem agora.');
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>

<style scoped>
.page {
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  box-sizing: border-box;
}

.contact-form {
  padding: 0 0.5rem;
}

.section-eyebrow {
  display: inline-block;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: #ff50a3;
  margin-bottom: 0.4rem;
}

.field-label {
  font-size: 0.82rem;
  font-weight: 600;
  color: #32355d;
  margin-bottom: 0.3rem;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}

.contact-input {
  background-color: #fafafa;
  border: 1.5px solid #ebebeb;
  border-radius: 0.75rem;
  padding: 0.7rem 1rem;
  font-size: 0.95rem;
  color: #32355d;
}

.contact-input:focus {
  background-color: #fff;
  border-color: #ff50a3;
  box-shadow: 0 0 0 3px rgba(255, 80, 163, 0.12);
}

.contact-btn {
  border-radius: 0.875rem;
  font-weight: 700;
  font-size: 1rem;
  padding: 0.85rem;
  letter-spacing: 0.03em;
}

.contact-btn:not(.contact-btn--success) {
  background: linear-gradient(135deg, #ff50a3 0%, #e0185d 100%);
  border: none;
  color: #fff;
}

.contact-btn:not(.contact-btn--success):hover:not(:disabled) {
  opacity: 0.92;
  transform: translateY(-1px);
}

.contact-btn--success {
  background: #fff;
  border: 1px solid #ebebeb;
  color: #32355d;
  cursor: default;
}
</style>
